module.exports = __webpack_public_path__ + "img/github.1123a385.svg";